const changeToTime = (time: number): string => {
    const d = Math.trunc(Math.trunc(time / 60 / 60) / 24);
    const h = String(Math.trunc(time / 60 / 60) % 24) + 'h ';
    const m = String(Math.trunc(time / 60) % 60) + 'm ';
    const s = String(time % 60) + 's';
    return d + (d <= 1 ? 'day ' : 'days ') + h + m + s;
}

export default changeToTime;